import react from 'react'
import v8 from './../../../images/v8.jpg'
import boiteIntro from './../../../images/boiteIntro.png'
import barline from './../../../images/Bar_line.png'
import boiteHero from './../../../images/boiteHero.jpg'

import boite2 from './../../../images/boite2.jpg'
import v4 from './../../../images/v4.png'

import gray_dots from './../../../images/gray_dots.jpg'
import biote_finish from '../../../images/biote_finish.png'

import {Link } from 'react-router-dom'


const First_Pane =() =>{
    return (

        <div>
        <div
        
            style={{ 
            backgroundImage: `-webkit-linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)), url(${boiteHero})`,
            backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)), url(${boiteHero})`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            paddingBottom: '50px',
            paddingTop: '100px',
            height: '120vh'
            }}
        
        
        >


            <div className='uk-container'>

                <div className='uk-grid' data-uk-grid>
                    <div className='uk-width-1-2@s'>
                        
               <h1 className='light header1 uk-margin-xlarge-top' uk-scrollspy="cls: uk-animation-slide-right; repeat: true">Boite 311 Residence</h1>
               <h5 className='light uk-margin-medium-top' uk-scrollspy="cls: uk-animation-fade; repeat: true">
                
                
Plot Number: 311, Cad zone C04, Dape District                              
Plot Title:    Certificate of Occupancy <br/>
Plot Size:    1,136.58M <br/>
Land Use:    Residential<br/>
Mode of Land Acquisition:     Joint Venture<br/>
Total No. Of Housing Units:    5 Units<br/>
Project Start Date:    July 2021<br/>

                
                
                </h5>
                    </div>

                    <div className='uk-width-1-2@s'>

                    </div>
                </div>

            </div>
           
        </div>

                <div className='uk-container'>
                                
                                      

                </div>


                

       {/*Next pane*/}
             <div className="" style={{backgroundColor:'#3FC6EB', padding:'40px'}}>
                 <div className="uk-container uk-margin-large-top uk-margin-large-bottom"

                 style={{ backgroundImage: `url(${gray_dots})`,
                 backgroundRepeat: 'no-repeat',
                 backgroundSize: 'cover',
                 paddingBottom: '10px',
               
                 height: '70vh'
                 }}
                 
                 >
                <div className="uk-width-1-1 uk-padding" >
                  
                 <img src={biote_finish} />


                </div>
                </div>
             </div>
</div>
    )
}




export default First_Pane